import { render } from "./HandBackLeft.vue?vue&type=template&id=4b8a3f07"
import script from "./HandBackLeft.vue?vue&type=script&lang=js"
export * from "./HandBackLeft.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__